import request from '@/utils/request'

const DAY = 24 * 60 * 60 * 1000

function pad(value) {
  return String(value).padStart(2, '0')
}

export function formatDate(date) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

function parseResponse(response) {
  let payload = response && response.data
  if (typeof payload === 'string') {
    try {
      payload = JSON.parse(payload)
    } catch (error) {
      throw new Error('大屏接口返回格式无效')
    }
  }
  if (!payload || Number(payload.code) !== 0) {
    throw new Error((payload && payload.message) || '大屏数据查询失败')
  }
  return payload
}

function get(path, params, snapshotId) {
  const headers = snapshotId ? { 'X-Dashboard-Snapshot-Id': snapshotId } : undefined
  return request({
    url: path,
    method: 'get',
    params,
    headers,
    showLoading: false
  }).then(parseResponse)
}

export function periodRange(period, now = new Date()) {
  const end = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  let start
  if (period === '本年') {
    start = new Date(end.getFullYear(), 0, 1)
  } else if (period === '自定义区间') {
    start = new Date(end.getTime() - 29 * DAY)
  } else {
    start = new Date(end.getFullYear(), end.getMonth(), 1)
  }
  return { startDate: formatDate(start), endDate: formatDate(end) }
}

export function selectedRange(dateRange) {
  if (!Array.isArray(dateRange) || dateRange.length !== 2 || !dateRange[0] || !dateRange[1]) return null
  return { startDate: dateRange[0], endDate: dateRange[1] }
}

export function rangeGranularity(dateRange) {
  const range = selectedRange(dateRange)
  if (!range) return 'day'
  const duration = new Date(`${range.endDate}T00:00:00`).getTime() - new Date(`${range.startDate}T00:00:00`).getTime()
  return duration > 62 * DAY ? 'month' : 'day'
}

export function historyRange(months = 12, now = new Date()) {
  const end = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const start = new Date(end.getFullYear(), end.getMonth() - months + 1, 1)
  return { startDate: formatDate(start), endDate: formatDate(end) }
}

export function dashboardQuery(period, communityId, dateRange) {
  const range = period === '自定义区间' ? selectedRange(dateRange) : null
  return Object.assign(range || periodRange(period), communityId ? { communityId } : {})
}

export function getDashboardContext(query, snapshotId) {
  return get('/dashboard/context', query, snapshotId)
}

export function getDashboardOverview(query, snapshotId) {
  return get('/dashboard/overview', query, snapshotId)
}

export function getDashboardFees(query, snapshotId, granularity = 'month') {
  return get('/dashboard/fees', Object.assign({}, query, { granularity }), snapshotId)
}

export function getDashboardRooms(query, snapshotId) {
  return get('/dashboard/rooms', query, snapshotId)
}

export function getDashboardOwners(query, snapshotId) {
  return get('/dashboard/owners', query, snapshotId)
}

export function getDashboardRepairs(query, snapshotId, granularity = 'day') {
  return get('/dashboard/repairs', Object.assign({}, query, { granularity }), snapshotId)
}

export function getDashboardAlerts(query, snapshotId) {
  return get('/dashboard/alerts', query, snapshotId)
}
